import React from "react";
import Helmet from "react-helmet";
import config from "../../meta/config";

const SEO = ({title, description}) => {
  // const title = config.siteTitle;
  // const description = config.siteDescription;
  const image = config.siteLogo;
  const url = config.siteUrl;

  return <Helmet>
      <title>{title}</title>
      <meta name="google-site-verification" content="JKZT-iWeHQgkbO_lUn8VIDUka6UlglUOm2tC9uFaPRI" />

      <html lang="en" />
      {/* General tags */}
      
      <meta name="description" content={description} />
      <meta name="title" content={title} />
      
      {/* <meta name="robots" content="nofollow" /> */}
      {/* OpenGraph tags */}
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="fb:app_id" content={config.siteFBAppID ? config.siteFBAppID : ""} />
    </Helmet>;
};

export default SEO;




// WEBPACK FOOTER //
// ./src/components/SEO/index.js